module.exports = __webpack_public_path__ + "static/media/hand-receiving.f268e584.svg";